import "react";
import { Button, ButtonGroup, ColorPicker, Label } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/FieldSharedConfigs.tsx
/**
* This component can be used inside any of the field Config components - it's a set of optional config
* that can be applied to any field.
*
* Example: padding, alignment, text colors, etc.
*/
var FieldSharedConfigs = ({ config, setOptionsKey }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-y-xs flex flex-col",
		children: [
			/* @__PURE__ */ jsxs("div", { children: [
				/* @__PURE__ */ jsx(Label, {
					className: "mb-1",
					children: "Color"
				}),
				/* @__PURE__ */ jsx(ColorPicker, {
					label: "Background",
					onChangeValue: (val) => setOptionsKey("bgColor", val),
					value: config.options.bgColor
				}),
				/* @__PURE__ */ jsx(ColorPicker, {
					label: "Text",
					onChangeValue: (val) => setOptionsKey("textColor", val),
					value: config.options.textColor
				})
			] }),
			/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Label, {
				className: "mb-1",
				children: "Align"
			}), /* @__PURE__ */ jsxs(ButtonGroup, {
				size: "sm",
				fullWidth: true,
				children: [
					/* @__PURE__ */ jsx(Button, {
						variant: config.options.alignX === "left" ? "main" : "neutral",
						onClick: () => setOptionsKey("alignX", "left"),
						children: "Left"
					}),
					/* @__PURE__ */ jsx(Button, {
						variant: config.options.alignX === "center" ? "main" : "neutral",
						onClick: () => setOptionsKey("alignX", "center"),
						children: "Center"
					}),
					/* @__PURE__ */ jsx(Button, {
						variant: config.options.alignX === "right" ? "main" : "neutral",
						onClick: () => setOptionsKey("alignX", "right"),
						children: "Right"
					})
				]
			})] }),
			/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Label, {
				className: "mb-1",
				children: "Padding"
			}), /* @__PURE__ */ jsxs("div", {
				className: "gap-xxs grid grid-cols-4",
				children: [
					/* @__PURE__ */ jsx(Label, { children: "Y-Axis" }),
					/* @__PURE__ */ jsx("span", {
						className: "col-span-3",
						children: /* @__PURE__ */ jsx("input", {
							onChange: (e) => setOptionsKey("pY", e.target.value),
							min: 0,
							max: 5,
							step: .5,
							value: config.options.pY || 0,
							type: "range"
						})
					}),
					/* @__PURE__ */ jsx(Label, { children: "X-Axis" }),
					/* @__PURE__ */ jsx("span", {
						className: "col-span-3",
						children: /* @__PURE__ */ jsx("input", {
							onChange: (e) => setOptionsKey("pX", e.target.value),
							min: 0,
							max: 5,
							step: .5,
							value: config.options.pX || 0,
							type: "range"
						})
					})
				]
			})] }),
			/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(Label, {
				className: "mb-1",
				children: "Margin"
			}), /* @__PURE__ */ jsxs("div", {
				className: "gap-xxs grid grid-cols-4",
				children: [
					/* @__PURE__ */ jsx(Label, { children: "Y-Axis" }),
					/* @__PURE__ */ jsx("span", {
						className: "col-span-3",
						children: /* @__PURE__ */ jsx("input", {
							onChange: (e) => setOptionsKey("mY", e.target.value),
							min: 0,
							max: 5,
							step: .5,
							value: config.options.mY || 0,
							type: "range"
						})
					}),
					/* @__PURE__ */ jsx(Label, { children: "X-Axis" }),
					/* @__PURE__ */ jsx("span", {
						className: "col-span-3",
						children: /* @__PURE__ */ jsx("input", {
							onChange: (e) => setOptionsKey("mX", e.target.value),
							min: 0,
							max: 5,
							step: .5,
							value: config.options.mX || 0,
							type: "range"
						})
					})
				]
			})] })
		]
	});
};
//#endregion
export { FieldSharedConfigs };

//# sourceMappingURL=FieldSharedConfigs.js.map